module.exports = __webpack_public_path__ + "img/btn-logout-th.ea41523f.png";